import React from 'react';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { SectionEyebrow } from './SectionEyebrow';
import { IMAGES, offerIncludes } from '../data/coachSystem';
export function OfferSection() {
  return <section id="offer" className="scroll-mt-4 border-y border-char-line bg-char-light py-11 sm:py-14" aria-labelledby="offer-title" data-id="element-72" data-mp="8lc0udwjnc7n">
      <div className="mx-auto w-full max-w-[42rem] px-4 text-center sm:px-6 lg:max-w-3xl" data-id="element-73" data-mp="ic6p1ntcolvq">
        <SectionEyebrow label="The complete offer" data-id="element-74" data-mp="me1zbht9e9ln" />
        <h2 id="offer-title" className="mt-4 font-display text-[1.95rem] font-semibold uppercase leading-[1.05] tracking-tight text-ivory sm:text-[2.5rem]" data-id="element-75" data-mp="mgwhf2osvibw">
          Get the complete Basketball Coach System™
        </h2>

        <img src={IMAGES.bundle} alt="The complete Basketball Coach System™ bundle of six professional coaching volumes and five bonuses." className="mx-auto -mb-1 mt-5 w-full max-w-[26rem] sm:max-w-[30rem]" data-id="element-76" data-mp="2t6b7ci7r7zm2" />

        <div className="mt-6 rounded-2xl border border-orange/25 bg-ink p-5 shadow-lift sm:p-8" data-id="element-77" data-mp="12pcyx1um07ym">
          <ul className="mx-auto max-w-sm space-y-2.5 text-left" data-id="element-78" data-mp="xuyy2jx6h8mk">
            {offerIncludes.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-79" data-mp="ow3ttddp28lw">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-orange" aria-hidden="true" data-id="element-80" data-mp="oxyf4ssvo2qi" />
                <span className="text-[0.94rem] font-medium text-ivory" data-id="element-81" data-mp="1gmrsmirwb1we">
                  {item}
                </span>
              </li>)}
          </ul>

          <div id="pricing" className="mt-7 scroll-mt-6 border-t border-char-line pt-7" data-id="element-82" data-mp="1cniz9f0rp61d">
            <p className="font-display text-[4.75rem] font-semibold leading-[0.85] text-orange sm:text-[5.75rem]" data-id="element-83" data-mp="169jb2gukw4t">
              $27
            </p>
            <p className="mt-3.5 font-display text-[0.78rem] font-semibold uppercase tracking-[0.22em] text-ivory" data-id="element-84" data-mp="3sb9ach1tjswl">
              One-time payment
            </p>
            <p className="mt-2.5 text-[0.82rem] text-ivory-muted" data-id="element-85" data-mp="2nydjqevb2xt">
              You can pay in your local currency at checkout.
            </p>

            <CtaButton label="Get instant access" action="checkout" size="lg" className="mt-5" data-id="element-86" data-mp="3kt1j1c8qxgyr" />
            <p className="mt-3 text-[0.82rem] text-ivory-dim" data-id="element-87" data-mp="3b2gp4240p0m6">
              Instant digital access • One-time payment • No subscription
            </p>
          </div>
        </div>

        <div className="mx-auto mt-6 flex max-w-xl items-start gap-3 text-left" data-id="element-88" data-mp="315u51fjimdl7">
          <ShieldCheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-orange" aria-hidden="true" data-id="element-89" data-mp="3645gtvtdey62" />
          <div data-id="element-90" data-mp="2s5oz79tyzn95">
            <h3 className="font-display text-[0.75rem] font-semibold uppercase tracking-[0.18em] text-ivory" data-id="element-91" data-mp="2s5yt38i4yek4">
              7-day guarantee
            </h3>
            <p className="mt-1 text-[0.85rem] leading-relaxed text-ivory-muted" data-id="element-92" data-mp="2dhovx869w2bn">
              Explore Basketball Coach System™ for seven days. If it isn’t the
              right fit for your coaching needs, contact us within the
              guarantee period according to the stated refund policy.
            </p>
          </div>
        </div>
      </div>
    </section>;
}